import React from 'react'
import { Link } from 'react-router-dom'

// material ui layout
import Box from '@mui/material/Box'

// material ui forms
import FormHelperText from '@mui/material/FormHelperText'

// shared components
import FormCard from 'components/atoms/FormCard'
import FormButton from 'components/atoms/FormButton'
import ErrorMessage from 'components/shared/ErrorMessage'
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'
import FormDatePickerWithValidation from 'components/shared/FormDatePickerWithValidation'

// local components
import MinAgeWarning from './MinAgeWarning'
import MaxAgeWarning from './MaxAgeWarning'
import AllergiesForm from './AllergiesForm'
import DietaryRestrictionsForm from './DietaryRestrictionsForm'
import GenderForm from './GenderForm'
import BirthdateForm from './BirthdateForm'
import SitsSeparatelyModal from './SitsSeparatelyModal'

const CamperForm = props => {
  const {
    // via EditCamperContainer:
    form, // via redux state
    mutationLoading, // via withMutation
    account, // via withQuery
    camper, // via withQuery
    allergies, // via withQuery
    dietaryRestrictions, // via withQuery
    sitsSeparately, // via withQuery
    season, // via withQuery
    onClickSubmit, // via withEventHandlers
    formErrors, // via withFormResults
    buttonText,
    redirect,

    setModal, // via withRedux

    // via CamperFormContainer:
    onChangeCamperFormField, // via withEventHandlers
    onChangeArrayField, // via withEventHandlers
    onChangeBooleanStringField, // via withEventHandlers
    onChangeStandardAllergyField, // via withAllergyEventHandlers
    onChangeCustomAllergyField, // via withAllergyEventHandlers
    onChangeDateField, // via withEventHandlers
    showFormFields = true
  } = props

  const {
    preferences: { onlineOnly }
  } = account

  return (
    <FormCard>
      <ErrorMessage />
      {showFormFields && (
        <form>
          <FormTextFieldWithValidation
            label="Child's First Name"
            field='firstName'
            form={form}
            onChange={onChangeCamperFormField}
            errors={formErrors}
            required
          />

          <FormTextFieldWithValidation
            label="Child's Last Name"
            field='lastName'
            form={form}
            onChange={onChangeCamperFormField}
            errors={formErrors}
            required
          />

          <GenderForm
            value={form.gender}
            formErrors={formErrors}
            onChangeCamperFormField={onChangeCamperFormField}
          />

          <BirthdateForm
            form={form}
            formErrors={formErrors}
            onChangeDateField={onChangeDateField}
          />

          <MinAgeWarning season={season} birthdate={form.birthdate} />
          <MaxAgeWarning season={season} birthdate={form.birthdate} />

          {!onlineOnly && (
            <FormTextFieldWithValidation
              label='School'
              field='school'
              form={form}
              onChange={onChangeCamperFormField}
              errors={formErrors}
              required
            />
          )}

          {!onlineOnly && (
            <>
              <AllergiesForm
                food
                form={form}
                allergies={allergies}
                sitsSeparately={sitsSeparately}
                formErrors={formErrors}
                onChangeCamperFormField={onChangeCamperFormField}
                onChangeBooleanStringField={onChangeBooleanStringField}
                onChangeStandardAllergyField={onChangeStandardAllergyField}
                onChangeCustomAllergyField={onChangeCustomAllergyField}
                setModal={setModal}
              />

              <AllergiesForm
                food={false}
                form={form}
                allergies={allergies}
                formErrors={formErrors}
                onChangeCamperFormField={onChangeCamperFormField}
                onChangeBooleanStringField={onChangeBooleanStringField}
                onChangeStandardAllergyField={onChangeStandardAllergyField}
                onChangeCustomAllergyField={onChangeCustomAllergyField}
              />

              <DietaryRestrictionsForm
                form={form}
                camper={camper}
                dietaryRestrictions={dietaryRestrictions}
                formErrors={formErrors}
                onChangeCamperFormField={onChangeCamperFormField}
                onChangeArrayField={onChangeArrayField}
                onChangeBooleanStringField={onChangeBooleanStringField}
              />

              <FormTextFieldWithValidation
                label='Current Medications'
                field='medications'
                form={form}
                onChange={onChangeCamperFormField}
                errors={formErrors}
                multiline
              >
                <FormHelperText>
                  Prescribed and over-the-counter.
                </FormHelperText>
              </FormTextFieldWithValidation>

              <FormTextFieldWithValidation
                label='Current Medical Conditions / Past Medical Treatment'
                field='medicalConditions'
                form={form}
                onChange={onChangeCamperFormField}
                errors={formErrors}
                multiline
              >
                <FormHelperText>
                  Description of any past medical treatment or current physical,
                  mental, or psychological conditions requiring medication,
                  treatment, or special restrictions or considerations while at
                  camp, including the inability to participate in any
                  activities.
                </FormHelperText>
              </FormTextFieldWithValidation>

              <FormTextFieldWithValidation
                label='Is your child up to date with all immunizations required by their school or local school district?'
                field='immunizations'
                form={form}
                onChange={onChangeCamperFormField}
                errors={formErrors}
                required
              />

              <FormDatePickerWithValidation
                label='Date of last tetanus shot'
                field='tetanusShotDate'
                form={form}
                onChange={onChangeDateField}
                errors={formErrors}
              />
            </>
          )}

          {!onlineOnly && (
            <>
              <FormTextFieldWithValidation
                label="Doctor's Name"
                field='doctorName'
                form={form}
                onChange={onChangeCamperFormField}
                errors={formErrors}
              />

              <FormTextFieldWithValidation
                label="Doctor's Phone Number"
                field='doctorPhoneNumber'
                type='phone'
                form={form}
                onChange={onChangeCamperFormField}
                errors={formErrors}
              >
                <FormHelperText>Area code required</FormHelperText>
              </FormTextFieldWithValidation>
            </>
          )}

          <FormTextFieldWithValidation
            label='Additional Comments'
            field='parentNotes'
            form={form}
            onChange={onChangeCamperFormField}
            errors={formErrors}
            multiline
          >
            <FormHelperText>
              Anything else you'd like to share about your child.
            </FormHelperText>
          </FormTextFieldWithValidation>

          <Box py={2} align='center'>
            <FormButton variant='outlined' component={Link} to={redirect}>
              Cancel
            </FormButton>
            <FormButton
              variant='contained'
              color='secondary'
              disabled={mutationLoading}
              onClick={onClickSubmit}
            >
              {buttonText}
            </FormButton>
          </Box>
        </form>
      )}
      <SitsSeparatelyModal />
    </FormCard>
  )
}

export default CamperForm
